import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext } from '../../shared/context/auth-context';
import { useParams } from "react-router-dom";
import Card from "../../shared/components/UIElements/Card";
import Button from "../../shared/components/formElements/Button";
import Modal from "../../shared/components/UIElements/Modal";
import { useHttpClient } from "../../shared/hooks/http-hook";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import "./ItemInfo.css";
import FloatingButton from "../../shared/components/UIElements/FloatingButton";
import { ITEM_TYPES } from "../components/itemTypes";
import { useWindow } from "../../shared/hooks/window-hook";
const ItemInfo = () => {
  const { width } = useWindow();
  const auth = useContext(AuthContext);
  const history = useHistory();
  const [showConfirmModal, setShowConfirmModal] = useState("");
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [loadedItem, setLoadedItem] = useState({
    style: "",
    company: "",
    color: "",
    USSize: "",
    EURSize: "",
    quantity: "",
    cost: "",
    price: "",
    website: "",
    type: ""
  });

  const itemID = useParams().itemId;
  
  useEffect(() => {
    const fetchItem = async () => {
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL+`/items/${itemID}`,
          "GET",
          null,
          {Authorization: 'Bearer '+ auth.token}
        );
        setLoadedItem(responseData.item);
      } catch (err) {}
    };
    fetchItem();
  }, [sendRequest, itemID, auth.token]);


  const showWarningHandler = (task) => {
    setShowConfirmModal(task);
  };

  const cancelWarningHandler = () => {
    setShowConfirmModal("");
  };

  const confirmDeleteHandler = async () => {
    setShowConfirmModal("");
    try {
      await sendRequest(process.env.REACT_APP_BACKEND_URL+`/items/${itemID}`, 
      "DELETE",
      null,
      {Authorization: 'Bearer '+ auth.token});
      history.push("/items");
    } catch (err) {}
  };



  const confirmMoveHandler = async () => {
    setShowConfirmModal("");
    
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+"/consignments/new",
        "POST",
        JSON.stringify({
          style: loadedItem.style,
          company: loadedItem.company,
          color: loadedItem.color,
          USSize: loadedItem.USSize,
          EURSize: loadedItem.USSize,
          quantity: loadedItem.quantity,
          cost:  loadedItem.cost,
          price: loadedItem.price,
          website: loadedItem.website,
          type: ITEM_TYPES.SPECIAL,
          description: ""
        }),
        { "Content-Type": "application/json" ,
        Authorization: 'Bearer '+ auth.token}
      );
    } catch (err) { return; }
    try {
      await sendRequest(process.env.REACT_APP_BACKEND_URL+`/items/${itemID}`,
       "DELETE",
       null,
       {Authorization: 'Bearer '+ auth.token}
      );
    } catch (err) { return; }
    // history.push(`/${loadedItem.type}`);
    history.push("/consignments");
  }




  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {isLoading && (
        <div className="center">
          <LoadingSpinner />
        </div>
      )}
      <Modal
        show={showConfirmModal}
        onCancel={cancelWarningHandler}
        header="Are you sure?"
        footerClass="items-item__modal-actions"
        footer={
          <React.Fragment>
            <Button inverse onClick={cancelWarningHandler}>
              CANCEL
            </Button>
            {showConfirmModal === "DELETE" ?
              <Button danger onClick={confirmDeleteHandler}>
              DELETE
            </Button> : <Button success onClick={confirmMoveHandler}>
              MOVE BACK
            </Button>
            }
          </React.Fragment>
        }
      >
        <p>
         { `Do you want to proceed and ${showConfirmModal.toLowerCase()} this item?`}
         {showConfirmModal === "MOVE BACK" && " This will return the cosignment item back to consignment table."}
        { showConfirmModal ==="DELETE" && " Please note that it can't be undone thereafter."}
        </p>
      </Modal>
      {!isLoading && loadedItem && (
        <li className="items-list">
          <Card className="items-item__content">
            <div className="container">
              <div className="row">
                <div className="col">
                  <form>
                    <div className="print-button">
                      <Button
                        inverse
                        onClick={(e) => {
                          e.preventDefault();
                          window.print();
                        }}
                      >
                        🖨️
                      </Button>
                    </div>
                    <br />
                    <h2 className="header-text">Item Details</h2>

                    <div className="flex justify-center">
                      <div className=" w-50 pa2 mr1 disabled-input">
                        <label>Style</label>
                        <input readOnly disabled type="text" value={loadedItem.style.split('_')[0]} />
                      </div>
                      <div className=" w-50 pa2 mr1 disabled-input">
                        <label>Company</label>
                        <input
                          readOnly
                          disabled
                          type="text"
                          value={loadedItem.company}
                        />
                      </div>
                    </div>
                    <div className="flex justify-center">
                      <div className=" w-50 pa2 mr1 disabled-input">
                        <label>Color</label>
                        <input readOnly disabled type="text" value={loadedItem.color} />
                      </div>
                      <div className=" w-50 pa2 mr1 disabled-input">
                        <label>US Size</label>
                        <input readOnly disabled type="text" value={loadedItem.USSize} />
                      </div>
                      <div className=" w-50 pa2 mr1 disabled-input">
                        <label>EUR Size</label>
                        <input readOnly disabled type="text" value={loadedItem.EURSize} />
                      </div>
                    </div>

                    <div className="flex justify-center">
                      <div className=" w-50 pa2 mr1 disabled-input">
                        <label>Quantity</label>
                        <input
                          readOnly
                          disabled
                          type="text"
                          value={loadedItem.quantity}
                        />
                      </div>
                      <div className=" w-50 pa2 mr1 disabled-input">
                        <label>Cost $</label>
                        <input readOnly disabled type="text" value={loadedItem.cost} />
                      </div>

                      <div className=" w-50 pa2 mr1 disabled-input">
                        <label>Price $</label>
                        <input readOnly disabled type="text" value={loadedItem.price} />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="image-container">
              <div className="items-avatar">
                {loadedItem.website && (
                  <img
                    src={loadedItem.website}
                    alt=""
                    width="auto"
                    height="auto"
                  />
                )}
              </div>
            </div>

            <div className="items-item__actions">
              <Button inverse to="/items">
                BACK
              </Button>
              <Button to={`/items/${itemID}/edit`}>EDIT</Button>
       {  width > 800 ?     <Button success to="/orders/new">
                SALE
              </Button> : ""}
              <Button danger onClick={() => showWarningHandler("DELETE")}>
                DELETE
              </Button>
              {loadedItem.type === "consignment" &&
                <Button inverse onClick={() => showWarningHandler("MOVE BACK")}>
                MOVE BACK
              </Button>}
            </div>
          </Card>
        </li>
      )}
      <FloatingButton icon={"back"} />
    </React.Fragment>
  );
};

export default ItemInfo;
